import React from 'react';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { openContactModal } from '../redux/global/globalReducer';

import scss from './Contact.module.scss';

function Contact() {
  const { t } = useTranslation('contact');
  const dispatch = useDispatch();

  const handleOpenContactModal = () => {
    dispatch(openContactModal());
  };

  return (
    <div className={scss.wrapper}>
      <button className={scss.button} onClick={handleOpenContactModal}>
        <div className={scss.iconWrapper}>
          <HeadsetMicIcon className={scss.icon} />
        </div>
        <span className={scss.label}>{t('contactUs')}</span>
      </button>
    </div>
  );
}

export default Contact;
